export default __webpack_public_path__ + "9c6c51c06d699d70df7dfe531b4c8ee9.png";